import type { FC } from 'react';

export const FooterInterstate: FC = () => {
    return null;
};

export default FooterInterstate;
